class CartOfferProgress extends HTMLElement {
  static previousSteps = {};

  connectedCallback() {
    const location = this.dataset.location;
    const step = Number(this.dataset.step);
    const previousStep = CartOfferProgress.previousSteps[location];
    CartOfferProgress.previousSteps[location] = step;

    document.dispatchEvent(new CustomEvent('cart-offer:change', { detail: { step } }));

    // The cart re-render replaces this element, so replay the change from the previous state.
    if (!previousStep || !step || previousStep === step) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.classList.add('is-instant');
    this.setStep(previousStep);
    this.offsetWidth;
    this.classList.remove('is-instant');
    this.setStep(step);
  }

  setStep(step) {
    this.querySelectorAll('[data-state]').forEach((state) => {
      state.classList.toggle('is-active', Number(state.dataset.state) === step);
    });
    this.querySelectorAll('.cart-offer__segment').forEach((segment, index) => {
      segment.classList.toggle('is-filled', index < step);
    });
  }
}

if (!customElements.get('cart-offer-progress')) customElements.define('cart-offer-progress', CartOfferProgress);

class ProductOfferProgress extends HTMLElement {
  connectedCallback() {
    this.onChange = (event) => this.setStep(event.detail.step);
    document.addEventListener('cart-offer:change', this.onChange);
  }

  disconnectedCallback() {
    document.removeEventListener('cart-offer:change', this.onChange);
  }

  setStep(step) {
    if (step === Number(this.dataset.step)) return;
    this.dataset.step = step;

    const total = this.querySelectorAll('.cart-offer__segment').length;
    this.classList.toggle('is-done', step >= total);
    this.querySelector('[data-offer-counter]').textContent = this.dataset.counter.replace('[count]', step);

    const bar = this.querySelector('[role="progressbar"]');
    bar.setAttribute('aria-valuenow', step);
    bar.setAttribute('aria-valuetext', this.dataset.valueText.replace('[count]', step));

    this.querySelectorAll('.cart-offer__segment').forEach((segment, index) => {
      segment.classList.toggle('is-filled', index < step);
    });
  }
}

if (!customElements.get('product-offer-progress')) customElements.define('product-offer-progress', ProductOfferProgress);
